const addZeroToMonthOrDay = (day) => {
  return day / 10 >= 1 ? day : `0${day}`
}

const parseDate = (datestring, type) => {
  const date = new Date(datestring)
  if (!datestring || !date) return null
  const month = addZeroToMonthOrDay(date.getMonth() + 1)
  if (type === 'YearMonth') return `${date.getFullYear()}년 ${month}월`
  const day = addZeroToMonthOrDay(date.getDate())
  if (type === 'YYYY-MM-DD') return `${date.getFullYear()}-${month}-${day}`
  else return `${date.getFullYear()}년 ${month}월 ${day}일`
}

const parseDateTime = (datestring, type) => {
  const date = new Date(datestring)
  if (!datestring || !date) return null

  const hours = date.getHours()
  const minutes = date.getMinutes()

  return `${date.getFullYear()}년 ${addZeroToMonthOrDay(date.getMonth() + 1)}월 ${date.getDate()}일 ${hours < 10 ? `0${hours}` : hours}:${minutes < 10 ? `0${minutes}` : minutes}`
}

const getYearMonthFromDate = timestamp => {
  const date = new Date(timestamp)
  const _month = date.getMonth() + 1
    // for safari
  const month = _month / 10 >= 1 ? _month : `0${_month}`
  return `${date.getFullYear()}-${month}`
}

const eventColorcode = {
  '오늘': 'purple',
  '선고기일': 'magenta',
  '변론기일': 'orange',
  '조정기일': 'blue',
  '심문기일': 'green',
  '조사기일': 'yellow',
  '집중증거조사기일': 'brown',
  '쟁점정리기일': 'black',
  '감정기일': 'lime',
  '조정사무수행일': 'red'
}
const userModalItems = [
  [
    {
      title: '공지사항',
      type: 'document'
    },
    {
      title: 'FAQ',
      type: 'document'
    }
  ],
  // [
  //   // {
  //   //   title: '사건 전체 삭제',
  //   //   type: 'button',
  //   //   action: 'deleteAllCases'
  //   // },
  //   {
  //     title: '나의 사건 서비스 탈퇴 하기',
  //     type: 'button',
  //     action: 'stopUsingService'
  //   }
  // ],
  [
    // {
    //   title: '알림',
    //   type: 'notification',
    //   enabled: false
    // },
    {
      title: '로그아웃',
      type: 'logout',
      buttonType: 'danger'
    }
  ]
]
const caseDetailPaginationCode = [
  // {
  //   label: '관리명칭',
  //   value: 's1',
  // },
  {
    label: '사건정보',
    value: 's2',
  },
  {
    label: '사건 연혁',
    value: 's3',
  }
]
const calendarClassNameCode = {
  small: 'react-calendar--mobile',
  middle: 'react-calendar--small',
  large: 'react-calendar'
}
const tileClassNameCode = {
  small: 'react-calendar__tile',
  middle: 'react-calendar__tile--small',
  large: 'react-calendar__tile'
}

function getScrollbarWidth() {

  // Creating invisible container
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll'; // forcing scrollbar to appear
  outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
  document.body.appendChild(outer);

  // Creating inner element and placing it in the container
  const inner = document.createElement('div');
  outer.appendChild(inner);

  // Calculating difference between container's full width and the child width
  const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

  // Removing temporary elements from the DOM
  outer.parentNode.removeChild(outer);

  return scrollbarWidth;

}

const textByStatus = {
  ACTIVE: '진행 중',
  CLOSED: '종결',
  PENDING: '로딩중',
  INVALID: '오류'
}

const agreementVersion = 'v1'
const courts = [
  {
    name: '고등법원',
    children: [
      {code: '000100', name: '대법원'},
      {code: '000200', name: '서울고등법원'},
      {code: '000201', name: '서울고등법원(춘천재판부)'},
      {code: '000202', name: '서울고등법원(인천재판부)'},
      {code: '000600', name: '대전고등법원'},
      {code: '000601', name: '대전고등법원(청주재판부)'},
      {code: '000300', name: '대구고등법원'},
      {code: '000400', name: '부산고등법원'},
      {code: '000401', name: '부산고등법원(창원재판부)'},
      {code: '000402', name: '부산고등법원(울산재판부)'},
      {code: '000500', name: '광주고등법원'},
      {code: '000501', name: '광주고등법원(제주재판부)'},
      {code: '000502', name: '광주고등법원(전주재판부)'},
      {code: '000800', name: '수원고등법원'},
      {code: '000700', name: '특허법원'},
      {code: '000230', name: '서울가정법원'},
      {code: '000220', name: '서울행정법원'},
      {code: '000221', name: '서울회생법원'},
    ]
  },
  {
    name: '서울',
    children: [
      {code: '000210', name: '서울중앙지방법원'},
      {code: '000211', name: '서울동부지방법원'},
      {code: '000212', name: '서울남부지방법원'},
      {code: '000213', name: '서울북부지방법원'},
      {code: '000215', name: '서울서부지방법원'},
    ]
  },
  {
    name: '경기도',
    children: [
      {code: '000214', name: '의정부지방법원'},
      {code: '214807', name: '고양지원'},
      {code: '214804', name: '남양주지원'},
      {code: '214801', name: '파주시법원'},
      {code: '214802', name: '포천시법원'},
      {code: '214808', name: '동두천시법원'},
      {code: '214803', name: '가평군법원'},
      {code: '214805', name: '연천군법원'},
      {code: '214806', name: '철원군법원'},
    ]
  },
  {
    name: '인천',
    children: [
      {code: '000240', name: '인천지방법원'},
      {code: '000241', name: '인천지방법원 부천지원'},
      {code: '240812', name: '김포시법원'},
      {code: '240811', name: '강화군법원'},
      {code: '000228', name: '인천가정법원'},
      {code: '000229', name: '인천가정법원 부천지원'},
    ]
  },
  {
    name: '수원',
    children: [
      {code: '000250', name: '수원지방법원'},
      {code: '000251', name: '성남지원'},
      {code: '000252', name: '여주지원'},
      {code: '000253', name: '평택지원'},
      {code: '250826', name: '안산지원'},
      {code: '000254', name: '안양지원'},
      {code: '250823', name: '용인시법원'},
      {code: '250824', name: '오산시법원'},
      {code: '250825', name: '광명시법원'},
      {code: '250821', name: '안성시법원'},
      {code: '251827', name: '광주시법원'},
      {code: '252828', name: '양평군법원'},
      {code: '252829', name: '이천시법원'},
      {code: '000302', name: '수원가정법원'},
      {code: '000303', name: '수원가정법원 성남지원'},
      {code: '000304', name: '수원가정법원 여주지원'},
      {code: '000305', name: '수원가정법원 평택지원'},
      {code: '000322', name: '수원가정법원 안산지원'},
      {code: '000306', name: '수원가정법원 안양지원'},
      {code: '000249', name: '수원회생법원'},
    ]
  },
  {
    name: '강원도',
    children: [
      {code: '000260', name: '춘천지방법원'},
      {code: '000261', name: '강릉지원'},
      {code: '000262', name: '원주지원'},
      {code: '000263', name: '속초지원'},
      {code: '000264', name: '영월지원'},
      {code: '260842', name: '홍천군법원'},
      {code: '260843', name: '양구군법원'},
      {code: '261845', name: '삼척시법원'},
      {code: '261846', name: '동해시법원'},
      {code: '264851', name: '정선군법원'},
      {code: '264853', name: '평창군법원'},
      {code: '264852', name: '태백시법원'},
      {code: '262847', name: '횡성군법원'},
      {code: '260841', name: '인제군법원'},
      {code: '260844', name: '화천군법원'},
      {code: '263848', name: '고성군법원'},
      {code: '263849', name: '양양군법원'},
    ]
  },
  {
    name: '대전',
    children: [
      {code: '000280', name: '대전지방법원'},
      {code: '000281', name: '대전지방법원 홍성지원'},
      {code: '000284', name: '대전지방법원 공주지원'},
      {code: '000282', name: '대전지방법원 논산지원'},
      {code: '000285', name: '대전지방법원 서산지원'},
      {code: '000283', name: '대전지방법원 천안지원'},
      {code: '280872', name: '금산군법원'},
      {code: '280871', name: '세종특별자치시법원'},
      {code: '281874', name: '보령시법원'},
      {code: '281873', name: '서천군법원'},
      {code: '281875', name: '예산군법원'},
      {code: '283877', name: '아산시법원'},
      {code: '285879', name: '태안군법원'},
      {code: '285881', name: '당진시법원'},
      {code: '282876', name: '부여군법원'},
      {code: '284878', name: '청양군법원'},
      {code: '000286', name: '대전가정법원'},
      {code: '000292', name: '대전가정법원 홍성지원'},
      {code: '000295', name: '대전가정법원 공주지원'},
      {code: '000293', name: '대전가정법원 논산지원'},
      {code: '000296', name: '대전가정법원 서산지원'},
      {code: '000294', name: '대전가정법원 천안지원'},
    ]
  },
  {
    name: '충북',
    children: [
      {code: '000270', name: '청주지방법원'},
      {code: '000271', name: '충주지원'},
      {code: '000272', name: '제천지원'},
      {code: '000273', name: '영동지원'},
      {code: '270863', name: '진천군법원'},
      {code: '270861', name: '보은군법원'},
      {code: '272865', name: '단양군법원'},
      {code: '271864', name: '음성군법원'},
      {code: '273866', name: '옥천군법원'},
      {code: '270862', name: '괴산군법원'},
    ]
  },
  {
    name: '대구',
    children: [
      {code: '000310', name: '대구지방법원'},
      {code: '000320', name: '대구지방법원 서부지원'},
      {code: '000311', name: '대구지방법원 안동지원'},
      {code: '000312', name: '대구지방법원 경주지원'},
      {code: '000317', name: '대구지방법원 포항지원'},
      {code: '000313', name: '대구지방법원 김천지원'},
      {code: '000314', name: '대구지방법원 상주지원'},
      {code: '000315', name: '대구지방법원 의성지원'},
      {code: '000316', name: '대구지방법원 영덕지원'},
      {code: '310895', name: '경산시법원'},
      {code: '310893', name: '칠곡군법원'},
      {code: '310891', name: '청도군법원'},
      {code: '310892', name: '영천시법원'},
      {code: '310894', name: '성주군법원'},
      {code: '310896', name: '고령군법원'},
      {code: '311897', name: '영주시법원'},
      {code: '311898', name: '봉화군법원'},
      {code: '313901', name: '구미시법원'},
      {code: '314903', name: '문경시법원'},
      {code: '314902', name: '예천군법원'},
      {code: '315904', name: '청송군법원'},
      {code: '315905', name: '군위군법원'},
      {code: '316906', name: '울진군법원'},
      {code: '316907', name: '영양군법원'},
      {code: '000318', name: '대구가정법원'},
      {code: '000399', name: '대구가정법원 안동지원'},
      {code: '000390', name: '대구가정법원 경주지원'},
      {code: '000395', name: '대구가정법원 포항지원'},
      {code: '000391', name: '대구가정법원 김천지원'},
      {code: '000392', name: '대구가정법원 상주지원'},
      {code: '000393', name: '대구가정법원 의성지원'},
      {code: '000394', name: '대구가정법원 영덕지원'},

    ]
  },
  {
    name: '부산',
    children: [
      {code: '000410', name: '부산지방법원'},
      {code: '000412', name: '부산지방법원 동부지원'},
      {code: '000414', name: '부산지방법원 서부지원'},
      {code: '000413', name: '부산가정법원'},
      {code: '000443', name: '부산회생법원'},
    ]
  },
  {
    name: '울산',
    children: [
      {code: '000411', name: '울산지방법원'},
      {code: '411911', name: '양산시법원'},
      {code: '000477', name: '울산가정법원'},
    ]
  },
  {
    name: '경남',
    children: [
      {code: '000420', name: '창원지방법원'},
      {code: '000431', name: '마산지원'},
      {code: '000421', name: '진주지원'},
      {code: '000422', name: '통영지원'},
      {code: '000423', name: '밀양지원'},
      {code: '000424', name: '거창지원'},
      {code: '420922', name: '창원남부시법원'},
      {code: '420923', name: '김해시법원'},
      {code: '420921', name: '함안군법원'},
      {code: '420924', name: '의령군법원'},
      {code: '421927', name: '사천시법원'},
      {code: '421928', name: '남해군법원'},
      {code: '421926', name: '하동군법원'},
      {code: '422931', name: '거제시법원'},
      {code: '422932', name: '고성군법원(경)'},
      {code: '423933', name: '창녕군법원'},
      {code: '424934', name: '합천군법원'},
      {code: '424935', name: '함양군법원'},
      {code: '421929', name: '산청군법원'},
    ]
  },
  {
    name: '광주',
    children: [
      {code: '000510', name: '광주지방법원'},
      {code: '000511', name: '광주지방법원 목포지원'},
      {code: '000512', name: '광주지방법원 장흥지원'},
      {code: '000513', name: '광주지방법원 순천지원'},
      {code: '000514', name: '광주지방법원 해남지원'},
      {code: '510946', name: '담양군법원'},
      {code: '511947', name: '함평군법원'},
      {code: '512951', name: '강진군법원'},
      {code: '513955', name: '구례군법원'},
      {code: '510942', name: '영광군법원'},
      {code: '510943', name: '나주시법원'},
      {code: '510944', name: '장성군법원'},
      {code: '510945', name: '화순군법원'},
      {code: '510941', name: '곡성군법원'},
      {code: '513956', name: '광양시법원'},
      {code: '513953', name: '고흥군법원'},
      {code: '513954', name: '여수시법원'},
      {code: '513952', name: '보성군법원'},
      {code: '511949', name: '무안군법원'},
      {code: '511948', name: '영암군법원'},
      {code: '514958', name: '완도군법원'},
      {code: '514959', name: '진도군법원'},
      {code: '000515', name: '광주가정법원'},
      {code: '000599', name: '광주가정법원 목포지원'},
      {code: '000590', name: '광주가정법원 장흥지원'},
      {code: '000591', name: '광주가정법원 순천지원'},
      {code: '000592', name: '광주가정법원 해남지원'},
    ]
  },
  {
    name: '전북',
    children: [
      {code: '000520', name: '전주지방법원'},
      {code: '000521', name: '군산지원'},
      {code: '000522', name: '정읍지원'},
      {code: '000523', name: '남원지원'},
      {code: '520971', name: '진안군법원'},
      {code: '520972', name: '김제시법원'},
      {code: '520973', name: '무주군법원'},
      {code: '520974', name: '임실군법원'},
      {code: '521975', name: '익산시법원'},
      {code: '522976', name: '부안군법원'},
      {code: '522977', name: '고창군법원'},
      {code: '523978', name: '장수군법원'},
      {code: '523979', name: '순창군법원'},
    ]
  },
  {
    name: '제주',
    children: [
      {code: '000530', name: '제주지방법원'},
      {code: '530991', name: '서귀포시법원'},
    ]
  },
  {
    name: '기타',
    children: [
      {code: '000110', name: '법원행정처'},
    ]
  },
]
// const getPath = () => {
//   const isDebug = process.env.NODE_ENV !== 'production'
//   const appPath = isDebug ? process.cwd() : path.resolve('./resources/')
//   return appPath
// }
const logoBase64 = `
  data:image/png;base64,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
`
export {
  parseDate,
  parseDateTime,
  getYearMonthFromDate,
  addZeroToMonthOrDay,
  userModalItems,
  eventColorcode,
  caseDetailPaginationCode,
  calendarClassNameCode,
  tileClassNameCode,
  getScrollbarWidth,
  textByStatus,
  courts,
  agreementVersion,
  logoBase64
}